class WishlistButton extends HTMLElement {
  constructor() {
    super();

    const _this = this;

    function swymCallbackFn() {

      // Add/remove Clicks
      _this.addEventListener("click", function(){
        var buttonAttributes = {
          "epi": _this.getAttribute('data-wl-epi'),
          "du": _this.getAttribute('data-wl-du'),
          "empi": _this.getAttribute('data-wl-empi'),
          "iu" : _this.getAttribute('data-wl-iu'),
          "pr": _this.getAttribute('data-wl-pr')
        }

        if(_this.classList.contains("is-added")){
          window._swat.removeFromWishList(
            buttonAttributes,
            function(r) {
              _this.classList.remove("is-added");
              const event = new Event('wishlist-check');
              window.dispatchEvent(event);
            });
        } else {
          window._swat.addToWishList(
            buttonAttributes,
          function(r) {
            _this.classList.add("is-added");
            const event = new Event('wishlist-check');
            window.dispatchEvent(event);
          });
        }

      });

    }
    if(!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);

  }

}

customElements.define('wishlist-button', WishlistButton);
